'use client';

import { useState } from 'react';

import { Check, ChevronDown } from 'lucide-react';

import { Command, CommandGroup, CommandItem } from '@/modules/common/components/ui/command';
import { Popover, PopoverContent, PopoverTrigger } from '@/modules/common/components/ui/popover';
import { cn } from '@/modules/common/lib/utils';

type Props = {
  options: string[];
  selected: string[];
  onChange: (selected: string[]) => void;
};

export default function CategoryMultiSelect({ options, selected, onChange }: Props) {
  const [open, setOpen] = useState(false);

  const toggleOption = (category: string) => {
    if (selected.includes(category)) {
      onChange(selected.filter((c) => c !== category));
    } else {
      onChange([...selected, category]);
    }
  };

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button
          aria-expanded={open}
          className="flex w-full max-w-[380px] items-center justify-between truncate py-2 text-5xl font-light"
        >
          {selected.length > 0 ?
            <span className="truncate">{selected.join(', ')}</span>
          : <span className="text-black">All categories</span>}
          <ChevronDown className="ml-2 h-10 w-10 shrink-0" />
        </button>
      </PopoverTrigger>
      <PopoverContent className="p-0">
        <Command>
          <CommandGroup className="max-h-[300px] overflow-y-auto py-4">
            {options.map((category) => (
              <CommandItem
                key={category}
                onSelect={() => toggleOption(category)}
                className="flex items-center"
              >
                <div
                  className={cn(
                    'mr-2 flex h-4 w-4 items-center justify-center rounded-sm border border-primary',
                    selected.includes(category) ? 'bg-primary text-white' : 'bg-white'
                  )}
                >
                  {selected.includes(category) && <Check className="h-3 w-3" />}
                </div>
                {category}
              </CommandItem>
            ))}
          </CommandGroup>
        </Command>
      </PopoverContent>
    </Popover>
  );
}
